<i class="section-title-icon" [uiType]="iconType" ui-icon uiTheme="fill"></i>
<h3>{{ title | localize }}</h3>
